
export const sum = (a,b) => {
    return a + b;
};

export const offsetTop = (elem) => {
    let offsetTop = 0;
    do {
        if ( !isNaN( elem.offsetTop ) )
        {
            offsetTop += elem.offsetTop;
        }
    } while( elem = elem.offsetParent );
    return offsetTop;
};

export const elementIndex = (node) =>{
    let cIndex = 0;
    while ( (node = node.previousElementSibling) ) {
        cIndex++;
    }
    return cIndex;
};

export const extend = (a, b) => {
    for(var key in b)
        if(b.hasOwnProperty(key))
            a[key] = b[key];
    return a;
};

export const wrap = (el, wrapper, classlist) => {
    el.parentNode.insertBefore(wrapper, el);
    classlist.forEach((item)=>{
        wrapper.classList.add(item);
    });
    wrapper.appendChild(el);
};
